import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Input from "antd/lib/input";
import Slider from "antd/lib/slider";
import InputNumber from "antd/lib/input-number";
import Form from "antd/lib/form";
import Modal from "antd/lib/modal";
import { wrap as wrapDialog, DialogPropType } from "@/components/DialogWrapper";

import "./DashboardBackgroundDialog.less";

function DashboardBackgroundDialog({ dialog, options, onSave, onPreview }) {
  const background = options.background || {};
  const [imageUrl, setImageUrl] = useState(background.image_url || "");
  const [opacity, setOpacity] = useState(background.opacity !== undefined ? background.opacity : 1.0);
  const [gridMargin, setGridMargin] = useState(options.gridMargin !== undefined ? options.gridMargin : 15);
  const [urlError, setUrlError] = useState("");

  // 实时预览：任意参数变化时触发 onPreview 回调
  useEffect(() => {
    if (onPreview) {
      onPreview({ background: { image_url: imageUrl, opacity }, gridMargin });
    }
  }, [imageUrl, opacity, gridMargin]); // eslint-disable-line react-hooks/exhaustive-deps

  function validateUrl(url) {
    if (url && !url.startsWith("https://")) {
      return "Background image URL must start with https://";
    }
    return "";
  }

  function handleSave() {
    const error = validateUrl(imageUrl);
    if (error) {
      setUrlError(error);
      return;
    }
    onSave({
      background: {
        image_url: imageUrl,
        opacity,
      },
      gridMargin,
    });
    dialog.close();
  }

  return (
    <Modal
      {...dialog.props}
      title="Dashboard Appearance"
      onOk={handleSave}
      onCancel={dialog.dismiss}
      okText="Save"
      cancelText="Cancel"
      okButtonProps={{ disabled: !!urlError }}>
      <Form layout="vertical" className="dashboard-background-form">
        <Form.Item
          label="Background Image URL (S3)"
          validateStatus={urlError ? "error" : ""}
          help={urlError}>
          <Input
            value={imageUrl}
            onChange={e => {
              setImageUrl(e.target.value);
              setUrlError("");
            }}
            placeholder="https://your-bucket.s3.amazonaws.com/bg.jpg"
          />
        </Form.Item>

        <Form.Item label={`Background Opacity: ${Math.round(opacity * 100)}%`}>
          <Slider
            min={0}
            max={100}
            value={Math.round(opacity * 100)}
            onChange={val => setOpacity(val / 100)}
          />
        </Form.Item>

        <Form.Item label="Widget Gap (px)">
          <InputNumber
            min={0}
            max={50}
            value={gridMargin}
            onChange={val => setGridMargin(val)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

DashboardBackgroundDialog.propTypes = {
  dialog: DialogPropType.isRequired,
  options: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onPreview: PropTypes.func,
};

DashboardBackgroundDialog.defaultProps = {
  options: {},
  onPreview: null,
};

export default wrapDialog(DashboardBackgroundDialog);
